import { call, put, select, takeLatest } from 'redux-saga/effects'
import { AssessmentConstants } from '../store/assessment.constant'
import { IAssessmentState } from '../store/assessment.types'
import { getAssessmentSelector } from '../selectors/getAssessment.selector'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import {
  clearFields,
  saveAssessment,
  setHideNeuroFields,
  setHideSepsisFields,
  setUpdateInputRows,
} from '../store/assessment.actions'
import { isEqual } from 'lodash'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getServiceIdSelector } from '../../../user/selectors'
import { getPcrIdSelector } from '../../../home/selectors'
import { IPcr } from '../../../pcr/store/pcr.types'

export function* setAction() {
  const assessmentState: IAssessmentState = yield select(getAssessmentSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const { action, _hideNeuroFields, _hideSepsisFields } = assessmentState

      let hideNeuroFieldsTemp = true
      let hideSepsisFieldsTemp = true
      if (action && action.id !== null) {
        hideNeuroFieldsTemp = action.name !== 'Neuro'
        hideSepsisFieldsTemp = action.name !== 'Sepsis'
      } else {
        hideNeuroFieldsTemp = true
        hideSepsisFieldsTemp = true
      }

      yield put(clearFields())
      if (hideNeuroFieldsTemp !== _hideNeuroFields) yield put(setHideNeuroFields(hideNeuroFieldsTemp))
      if (hideSepsisFieldsTemp !== _hideSepsisFields) yield put(setHideSepsisFields(hideSepsisFieldsTemp))
      yield put(setUpdateInputRows(true))

      // update type in the list
      if (pcrDoc.patient?.assessmentsStateList && pcrDoc.patient?.assessmentsStateList.length) {
        const index = pcrDoc.patient.assessmentsStateList.findIndex((data) => data.key === assessmentState.key)

        if (index !== -1) {
          if (!isEqual(pcrDoc.patient.assessmentsStateList[index].action, action)) {
            yield put(saveAssessment())
          }
        }
      } else {
        yield put(saveAssessment())
      }
    } catch (e) {
      yield put(throwPcrException(`setAction() error: ${e}`))
    }
  }
}
export function* setActionSaga() {
  yield takeLatest([AssessmentConstants.SET_ACTION], performWithMutexHOG, setAction)
}
